import GATSBY_COMPILED_MDX from "/Users/ericbenoit/Sites/goinvo.com/src/case-studies/commonhealth-smart-health-cards.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {MDXProvider} from "@mdx-js/react";
import Helmet from 'react-helmet';
import Layout from './layout';
import Image from '../image';
import Hero from '../hero';
import Results from '../results';
import Columns from '../columns';
import Card from '../card';
import ImageBlock from '../image-block';
import References from '../references';
import {extractWorkItemLinkDetails, concatCaseStudiesAndFeatures, findCaseStudyById, mediaUrl} from '../../helpers';
import config from '../../../config';
const CaseStudyLayout = ({data: caseStudies, children}) => {
  const {mdx} = caseStudies;
  if (!mdx || !children) {
    return;
  }
  const caseStudiesWithFeatures = concatCaseStudiesAndFeatures({
    caseStudies,
    filterFeatures: false
  });
  const caseStudy = findCaseStudyById(caseStudies, mdx.id);
  const meta = [{
    name: 'twitter:site',
    content: '@goinvo'
  }, {
    name: 'twitter:card',
    content: 'summary_large_image'
  }, {
    name: 'twitter:title',
    content: caseStudy.frontmatter.title
  }, {
    name: 'twitter:image',
    content: mediaUrl(caseStudy.frontmatter.image)
  }, {
    property: 'og:title',
    content: caseStudy.frontmatter.title
  }, {
    property: 'og:image',
    content: mediaUrl(caseStudy.frontmatter.image)
  }];
  if (caseStudy.frontmatter.metaDescription) {
    meta.push({
      name: 'description',
      content: caseStudy.frontmatter.metaDescription
    }, {
      name: 'twitter:description',
      content: caseStudy.frontmatter.metaDescription
    }, {
      property: 'og:description',
      content: caseStudy.frontmatter.metaDescription
    });
  }
  return React.createElement(Layout, null, React.createElement(Helmet, {
    title: `${caseStudy.frontmatter.title} - GoInvo`,
    meta: meta
  }), React.createElement(MDXProvider, {
    components: {
      h1: ({children, ...props}) => React.createElement("h1", Object.assign({
        className: "header--xl margin-top--double margin-bottom--half"
      }, props), children),
      h2: ({children, ...props}) => React.createElement("h2", Object.assign({
        className: "header--lg margin-top--double text--center"
      }, props), children),
      h3: ({children, ...props}) => React.createElement("h3", Object.assign({
        className: "header--md margin-bottom--half"
      }, props), children),
      h4: ({children, ...props}) => React.createElement("h4", Object.assign({
        className: "header--sm margin-bottom--half"
      }, props), children),
      p: ({children, ...props}) => React.createElement("p", {
        className: "text--gray margin-top--none margin-bottom--double"
      }, children),
      ul: ({children, ...props}) => React.createElement("ul", {
        className: "ul margin-top--none margin-bottom--double"
      }, children),
      img: props => React.createElement(Image, Object.assign({
        className: "image--max-width",
        sizes: config.sizes.fullInsideMediumMaxWidth
      }, props))
    }
  }, React.createElement("div", {
    className: `case-study ${caseStudy.parent.name}`
  }, React.createElement(Hero, {
    image: caseStudy.frontmatter.image
  }), React.createElement("div", {
    className: "max-width max-width--md content-padding"
  }, children), caseStudy.frontmatter.results ? React.createElement(Results, {
    stats: caseStudy.frontmatter.results
  }) : null, React.createElement("div", {
    className: "background--blue pad-vertical--double pad-bottom--quad"
  }, React.createElement("div", {
    className: "max-width content-padding"
  }, React.createElement("h3", {
    className: "header--md"
  }, "Up next"), React.createElement(Columns, {
    columns: 3
  }, !!caseStudiesWithFeatures.length && caseStudy.frontmatter.upNext.map(id => {
    const nextItem = caseStudiesWithFeatures.find(item => item.slug === id || item.id === id);
    const {link, externalLink, suppressNewTab} = extractWorkItemLinkDetails(nextItem);
    return React.createElement(Card, {
      key: link,
      link: link,
      externalLink: externalLink,
      suppressNewTab: suppressNewTab
    }, React.createElement(ImageBlock, {
      title: nextItem.title,
      image: nextItem.image,
      caption: nextItem.caption,
      hoverable: true
    }));
  })))), caseStudy.frontmatter.references ? React.createElement("div", {
    className: "background--gray pad-vertical"
  }, React.createElement("div", {
    className: "max-width content-padding"
  }, React.createElement(References, {
    references: caseStudy.frontmatter.references
  }))) : null)));
};
export const pageQuery = graphql`
  query CaseStudyLayoutQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
    }
    allMdx(filter: { frontmatter: { hidden: { eq: false } } }) {
      nodes {
        id
        parent {
          ... on File {
            name
          }
        }
        frontmatter {
          title
          image
          client
          categories
          caption
          results {
            stat
            description
          }
          references {
            title
            link
          }
          upNext
          metaDescription
        }
        fields {
          slug
        }
      }
    }
  }
`;
CaseStudyLayout
export default function GatsbyMDXWrapper(props) {
  return React.createElement(CaseStudyLayout, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
